import axios from 'axios';
export const apiRequest = async (
  url,
  method = 'GET',
  body = {},
  token,
  handleLogout
) => {
  if (!token) {
    handleLogout();
    return [];
  }
  try {
    const { data } = await axios({
      url: `${process.env.REACT_APP_BASE_URL}${url}`,
      // url: `${url}`,
      method,
      data: method !== 'GET' ? body : undefined,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`,
      },
    });

    return data;
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    if (error.response?.status === 401) handleLogout();
    return [];
  }
};
export const directApiRequest = async (
  url,
  method = 'GET',
  body = {},
  token,
  handleLogout
) => {
  if (!token) {
    handleLogout();
    return [];
  }
  try {
    const { data } = await axios({
      url, // 👈 full URL directly passed
      method,
      data: method !== 'GET' ? body : undefined,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`,
      },
    });

    return data;
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    if (error.response?.status === 401) handleLogout();
    return [];
  }
};

